import React from 'react';
import VolumeControl from './VolumeControl';

const TopBar = ({ 
  gameState,
  players,
  observers,
  myPlayerId,
  isObserver,
  volume,
  audioEnabled,
  onVolumeChange
}) => {
  const renderCenterInfo = () => {
    if (gameState === 'lobby') {
      return (
        <span>
          Lobby - Players: {players.size}/8 
          {observers.length > 0 && ` | Observers: ${observers.length}`}
        </span>
      );
    }
    
    if (gameState === 'playing') {
      const myPlayer = Array.from(players.values()).find(p => p.playerId === myPlayerId);
      const playerName = myPlayer?.nickname || `Player ${myPlayerId + 1}`;
      
      return (
        <span>
          {isObserver ? 'Observing' : playerName} | 
          Players: {players.size}/8 
          {observers.length > 0 && ` | Observers: ${observers.length}`}
        </span>
      );
    }
    
    return null;
  };

  return (
    <div style={{ 
      backgroundColor: '#1a1a1a',
      borderBottom: '1px solid #333',
      padding: '10px 20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      height: '50px'
    }}>
      <h3 style={{ margin: 0, fontSize: '18px' }}>La Bomba Hombre</h3>
      
      <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
        {renderCenterInfo()}
      </div>
      
      <VolumeControl
        volume={volume}
        audioEnabled={audioEnabled}
        onVolumeChange={onVolumeChange}
      />
    </div>
  );
};

export default TopBar;